// extracted by mini-css-extract-plugin
export default {"rootClassName":"crud-with-steps-step-menu"};